import React from 'react';
import typography from '../../utils/typography';
import colors from '../../utils/colors';

const Badge = ({ 
  text, 
  variant = 'primary',
  size = 'small',
  className = '' 
}) => {
  const getVariantStyles = () => {
    const accentColor = colors.accent.brand || '#FD429C';
    const variants = {
      primary: {
        backgroundColor: `${accentColor}1A`, // 10% opacity
        borderColor: 'transparent',
        color: accentColor // 100% opacity
      },
      secondary: {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        borderColor: 'transparent',
        color: colors.text.primary || '#FAF7F5'
      },
      tertiary: {
        backgroundColor: colors.bg.secondary || '#252020',
        borderColor: 'transparent',
        color: colors.text.primary || '#FAF7F5'
      }
    };
    
    return variants[variant] || variants.primary;
  };

  const getSizeStyles = () => {
    const sizes = {
      small: {
        padding: '4px 8px',
        ...typography.xsmall.regular
      }
    };
    
    return sizes[size] || sizes.small;
  };

  const variantStyles = getVariantStyles();
  const sizeStyles = getSizeStyles();

  const showBorder = variantStyles.borderColor !== 'transparent';

  return (
    <div 
      className={`flex justify-center items-center flex-shrink-0 overflow-hidden rounded-full ${showBorder ? 'border' : ''} ${className}`}
      style={{
        ...variantStyles,
        ...sizeStyles,
        ...(showBorder && {
          borderWidth: '1px',
          borderStyle: 'solid'
        })
      }}
    >
      <p className="text-left" style={{ color: variantStyles.color }}>
        {text}
      </p>
    </div>
  );
};

export default Badge;